import api from '../utils/api';
import type {
  Cliente,
  CreateClienteDto,
  UpdateClienteDto,
  ClienteFilters
} from '../types/cliente.types';
import type { PaginatedResponse, QueryParams } from '../types/common.types';

export const clientiService = {
  // Get all clienti with pagination and filters
  getAll: async (params: QueryParams & ClienteFilters): Promise<PaginatedResponse<Cliente>> => {
    const response = await api.get('/clienti', { params });
    return response.data;
  },

  // Get cliente by ID
  getById: async (id: string): Promise<Cliente> => {
    const response = await api.get(`/clienti/${id}`);
    return response.data;
  },

  // Search clienti (for autocomplete)
  search: async (query: string): Promise<Cliente[]> => {
    const response = await api.get('/clienti/search', { params: { q: query, limit: 10 } });
    return response.data;
  },

  // Create new cliente
  create: async (data: CreateClienteDto): Promise<Cliente> => {
    const response = await api.post('/clienti', data);
    return response.data;
  },

  // Update cliente
  update: async (id: string, data: UpdateClienteDto): Promise<Cliente> => {
    const response = await api.patch(`/clienti/${id}`, data);
    return response.data;
  },

  // Delete cliente
  delete: async (id: string): Promise<void> => {
    await api.delete(`/clienti/${id}`);
  },

  // Toggle cliente active status
  toggleActive: async (id: string): Promise<Cliente> => {
    const response = await api.patch(`/clienti/${id}/toggle-active`);
    return response.data;
  },

  // Get cliente statistics
  getStats: async (id: string) => {
    const response = await api.get(`/clienti/${id}/stats`);
    return response.data;
  },

  // Restore deleted cliente
  restore: async (id: string): Promise<Cliente> => {
    const response = await api.put(`/clienti/${id}/restore`);
    return response.data;
  },

  // Hard delete cliente (permanent)
  hardDelete: async (id: string): Promise<void> => {
    await api.delete(`/clienti/${id}/permanent`);
  }
};

export default clientiService;
